import { Grid, Stack, Title } from 'ui';

const ProfileSettingsTemplate = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => {
  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 6, lg: 6 }} offset={{ base: 0, md: 3, lg: 3 }}>
        <Stack>
          <Title order={2}>{title}</Title>
          {children}
        </Stack>
      </Grid.Col>
    </Grid>
  );
};
export { ProfileSettingsTemplate };
